export var fontSizes = {
    xxxxs: 8,
    xxxs: 10,
    xxs: 12,
    xs: 14,
    s: 16,
    m: 18,
    l: 24,
    xl: 28,
    xxl: 40,
    xxxl: 48,
};
//# sourceMappingURL=fontSizes.js.map